import React from "react";
import NewsletterThirtyOne from "../component/NewsletterThirtyOne";

function NewsletterThirtyOneContainer() {
  return <NewsletterThirtyOne />;
}

export default NewsletterThirtyOneContainer;
